//Local_Login

import React, { useState, useEffect } from 'react';
import { requestPermission } from '../firebase/firebase-messaging';
import { Card, Form, Button, Modal } from 'react-bootstrap';
import close from '../Asset/close.svg';
import fltlogo from '../Asset/SafeLog_Logo.png';
import { useNavigate } from 'react-router-dom';
import lock from '../Asset/lock.svg'
import Alert from './Alert';
import { setUserInfo, getUserInfo, getDashboard, setDashboard, encryptPlainText } from './functions/userInfo';
import { environment } from './functions/environment';
import { signIn } from '../Azure-ad/authService';
import { useAuth } from '../Azure-ad/AuthContext'

function Local_Login(props) {
    // const { instance } = useMsal();
    const { setToken } = useAuth();

    let [alert, setAlert] = useState({
        msg: "",
        status: false
    });
    let [term, setTerm] = useState("");
    let [policy, setPolicy] = useState("");
    let [infoType, setInfoType] = useState("");
    let [infoShow, setInfoShow] = useState(false);
    let [src, setSrc] = useState("");
    useEffect(() => {
        getTerm();
        getPolicy();
        sessionStorage.removeItem("msal.interaction.status");
    }, []);

    async function handelADLogin(type) {
        if (!loginData.check) {
            setErrorMsg({ ...errorMsg, login: { error: true, msg: "Please agree all Terms of Use and Privacy Policy" } });
        }
        else {
            sessionStorage.setItem("adType", type);
            try {
                await signIn(type,setToken);
                console.log('Signed in successfully');
            } catch (error) {
                console.error('Error signing in:', error);
            }
        }
    }

    useEffect(() => {
        if ((policy != "" || term != "") && infoType != "") {
            handleInfoType(infoType);
        }
    }, [policy, term])
    //for terms and privacey policy
    function handleInfoType(type) {
        console.log("infptype", type);
        setInfoType(type);
        setInfoShow(true);
        if (policy != "" || term != "") {
            const binaryData = base64ToBinary(type === "policy" ? policy : term);
            const blob = createBlob(binaryData);
            const objectURL = createObjectURL(blob);
            console.log("objectURL", objectURL);
            setSrc(objectURL);
        }
        //  window.open(objectURL+"#toolbar=0&navpanes=0", "_blank");

    }
    function base64ToBinary(base64String) {
        // Cut the prefix `data:application/pdf;base64` from the raw base 64
        const base64WithoutPrefix = base64String.substr('data:application/pdf;base64,'.length);
        return atob(base64WithoutPrefix);
    }
    function createBlob(binaryData) {
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);

        for (let i = 0; i < binaryData.length; i++) {
            uint8Array[i] = binaryData.charCodeAt(i);
        }

        return new Blob([arrayBuffer], { type: 'application/pdf' });
    }
    function createObjectURL(blob) {
        return URL.createObjectURL(blob);
    }
    function setSrc1sr() {
        const binaryData = base64ToBinary(infoType === "policy" ? policy : term);
        const blob = createBlob(binaryData);
        const objectURL = createObjectURL(blob);
        return objectURL;
    }
    function getPolicy() {
        fetch(environment.baseUrl + "privacyPolicies", {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                // 'Authorization': 'Bearer ' + token
            }
        }).then((result) => {
            result.json().then((res) => {
                setPolicy(res.data);
            })
        })
    }
    function getTerm() {
        fetch(environment.baseUrl + "termsAndContion", {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                // 'Authorization': 'Bearer ' + token
            }
        }).then((result) => {
            result.json().then((res) => {
                setTerm(res.data)
            })
        })
    }
    //for model of forgat password
    const [showm, setShowm] = useState(false);
    const handleClose = () => {
        setShowm(false);
        setScreen({
            forgetPassword: true,
            verifyOtp: false,
            resetPassword: false
        });
        setForgotData({
            emailID: "",
            otp: "",
            newPassword: "",
            confirmPassword: ""
        })
    };
    const handleShow = () => setShowm(true);
    //for model
    const navigate = useNavigate();
    let [deviceID, setDeviceID] = useState("");

    // for device ID
    function dec2hex(dec) {
        return dec < 10
            ? '0' + String(dec)
            : dec.toString(16)
    }

    // generateId :: Integer -> String
    function generateId(len) {
        var arr = new Uint8Array((len || 40) / 2)
        window.crypto.getRandomValues(arr)
        return Array.from(arr, dec2hex).join('')
    }

    // set device ID cookie
    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/;Secure";
    }

    // get device ID cookie
    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
    // check device ID cookie is present or not in device
    function checkCookie() {
        let did = getCookie("deviceID");
        if (did != "") {
            setCookie("deviceID", did, 90);
            setDeviceID(did);
        } else {
            let id = generateId(20);
            setCookie("deviceID", id, 90);
            setDeviceID(id)
        }
    }
    // for check user is already login or not
    useEffect(() => {
        requestPermission();
        checkCookie();
        if (sessionStorage.getItem('userInfo')) {
            let loginUser = getUserInfo();
            if (loginUser.token != "" || loginUser.token != null) {
                //for redirect user as per user type
                if (loginUser.userType == "admin") {
                    navigate('/accounts');
                }
                else if (loginUser.userType == "technician_user") {
                    navigate('/preventive_maintenance');
                }
                else {
                    navigate('/my-equipment');
                }
            }
        }
        else {
            props.aapFun(false);
        }
    }, [])

    // for store user input of login form
    let [loginData, setLoginData] = useState({
        userName: "",
        password: "",
        check: false,
    });
    let [show, setShow] = useState(false);
    //store password visibility
    let [type, setType] = useState({
        type: 'password',
        iclass: 'fa fa-eye'
    });

    //for show/hide password
    function togglePassword() {
        setShow(!show);
        if (show) {
            setType({ type: 'text', iclass: 'fa fa-eye-slash' });
        }
        else {
            setType({ type: 'password', iclass: 'fa fa-eye' });
        }
    }

    //login form validation
    function loginUser(e) {
        e.preventDefault();
        if (loginData.userName == "") {
            setErrorMsg({ ...errorMsg, login: { error: true, msg: "Please enter User ID" } });
        }
        else if (loginData.password == "") {
            setErrorMsg({ ...errorMsg, login: { error: true, msg: "Please enter Password" } });
        }
        else if (!loginData.check) {
            setErrorMsg({ ...errorMsg, login: { error: true, msg: "Please agree all Terms of Use and Privacy Policy" } });
        }
        else {
            let aes = encryptPlainText(loginData.userName + ":" + loginData.password);
            loginApi(aes);
        }
    }
    // store user input in state
    function getFormData(e) {
        if (e.target.name === "check") {
            setLoginData({ ...loginData, [e.target.name]: e.target.checked });
        }
        else {
            setLoginData({ ...loginData, [e.target.name]: e.target.value });
        }
        setErrorMsg({ ...errorMsg, login: { error: false } })
    }

    //get accessible dashborad list
    function getDashboardByUser(token) {
        fetch(environment.baseUrl + "getDashboardByUser?", {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then((result) => {
            result.json().then((res) => {
                let temp = [];
                if (res.data.result.length) {
                    res.data.result.map((item) =>
                        temp.push(item.dashboardID)
                    )
                    setDashboard(temp);
                    const dashboard = getDashboard();

                    if (dashboard) {
                        navigate('/my-equipment');
                    }
                    else {
                        navigate('/profile');
                    }
                }
            })
        })
    }
    //check which browser user is used
    function getBrowserName() {
        if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1) {
            return ('Opera');
        }
        else if (navigator.userAgent.indexOf("Edg") != -1) {
            return ('Edge');
        }
        else if (navigator.userAgent.indexOf("Chrome") != -1) {
            return ('Chrome');
        }
        else if (navigator.userAgent.indexOf("Safari") != -1) {
            return ('Safari');
        }
        else if (navigator.userAgent.indexOf("Firefox") != -1) {
            return ('Firefox');
        }
        else if ((navigator.userAgent.indexOf("MSIE") != -1) || (!!document.documentMode == true)) //IF IE > 10
        {
            return ('IE');
        }
        else {
            return ('unknown');
        }
    }
    // login API call
    function loginApi(val) {
        let fcm = sessionStorage.getItem("fcm");
        fetch(environment.baseUrl + "usersLogin?", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + val
            },
            body: JSON.stringify({
                deviceType: "web",
                deviceID: deviceID,
                deviceDetails: {
                    webBrowser: getBrowserName(),
                },
                firebaseToken: fcm // temporry hide unhide on confirmation
            })
        }).then((result) => {
            result.json().then((res) => {
                if (res.code === 200 && res.data.result.userType != "") {
                    setUserInfo(res.data.result);

                    if (res.data.result.userType == "admin") {
                        sessionStorage.setItem("Dashboards", JSON.stringify([null]));
                        navigate('/accounts');
                    }
                    else if (res.data.result.userType == "technician_user") {
                        sessionStorage.setItem("Dashboards", JSON.stringify([null]));
                        navigate('/preventive_maintenance');
                    }
                    else if (res.data.result.userType === "account_user") {
                        getDashboardByUser(res.data.result.token);
                    }
                    props.aapFun(true);
                }
                else if (res.code === 200 && res.data.result.userType == "") {
                    setErrorMsg({ ...errorMsg, login: { error: true, msg: "User type is not defined" } })
                }
                else {
                    setErrorMsg({ ...errorMsg, login: { error: true, msg: res.msg } })
                }
            })
        })
    }

    //forgot password functinality
    let [forgotData, setForgotData] = useState({
        emailID: "",
        otp: "",
        newPassword: "",
        confirmPassword: ""
    });
    let [screen, setScreen] = useState({
        forgetPassword: true,
        verifyOtp: false,
        resetPassword: false
    });
    let [verifyApiData, setVerifyApiData] = useState();
    let [errorMsg, setErrorMsg] = useState({
        email: {
            error: false,
            // msg:"Please enter email ID first"
        },
        otp: {
            error: false,
            msg: ""
        },
        password: {
            error: false,
            msg: ""
        },
        login: {
            error: false
        }
    });
    // store forgetpassword data
    function getForgotData(e) {
        setForgotData({ ...forgotData, [e.target.name]: e.target.value });
        if (e.target.name == "emailID" && e.target.value != "") {
            setErrorMsg({ ...errorMsg, email: { error: false } });
        }
        else if (e.target.name == "otp" && e.target.value != "") {
            setErrorMsg({ ...errorMsg, otp: { error: false } });
        }
        else if (e.target.name == "newPassword" && e.target.value != "" || e.target.name == "confirmPassword" && e.target.value != "") {
            setErrorMsg({ ...errorMsg, password: { error: false, msg: "" } })
        }
    }
    // send otp API call
    function sendOtpToEmail() {
        if (forgotData.emailID != "") {
            fetch(environment.baseUrl + "sendEmailOTP", {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ "emailID": forgotData.emailID })
            }).then((result) => {
                result.json().then((res) => {
                    if (res.code === 200) {
                        setScreen({
                            forgetPassword: false,
                            verifyOtp: true,
                            resetPassword: false
                        });
                        startCountDown();
                    }
                    else {
                        setAlert({
                            msg: res.msg,
                            status: true
                        })
                    }
                })
            })
        }
        else {
            setErrorMsg({ ...errorMsg, email: { error: true } })
        }
    }

    //verfit OTP API call
    function verifySendOtp() {
        if (forgotData.otp != "" && forgotData.otp.length == 4) {
            fetch(environment.baseUrl + "verifyOTPEmail", {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ emailID: forgotData.emailID, otp: forgotData.otp })
            }).then((result) => {
                result.json().then((res) => {
                    if (res.code === 200) {
                        setVerifyApiData(res.data.result);
                        setScreen({
                            forgetPassword: false,
                            verifyOtp: false,
                            resetPassword: true
                        });
                    }
                    else {
                        setErrorMsg({ ...errorMsg, otp: { error: true, msg: res.msg } })
                    }
                })
            })
        }
        else {
            setErrorMsg({ ...errorMsg, otp: { error: true, msg: "Please enter OTP of 4 digit" } });
        }
    }
    // check if it is 3 or more consecutive digits or not. e.g. 123, 321
    function checkSequence(pass) {
        let isSeq = false;
        for (let i = 0; i < pass.length; i++) {
            if (i + 2 < pass.length && !isNaN(pass[i]) && !isNaN(pass[i + 1]) && !isNaN(pass[i + 2])) {
                let diff1 = Math.abs(parseInt(pass[i] - pass[i + 1]));
                let diff2 = Math.abs(parseInt(pass[i + 1] - pass[i + 2]));

                if (diff1 == 1 && diff2 == 1) {
                    isSeq = true;
                    break;
                }
            }
        }
        return isSeq;
    }
    function setNewPassword() {
        // set new passwordn form validation
        if (forgotData.newPassword == "") {
            setErrorMsg({ ...errorMsg, password: { error: true, msg: "Please enter new password" } })
        }
        else if (/\s/g.test(forgotData.newPassword)) {
            setErrorMsg({ ...errorMsg, password: { error: true, msg: "Password should not contain space" } })
        }
        else if (forgotData.newPassword.length < 10 || forgotData.newPassword.length > 16) {
            setErrorMsg({ ...errorMsg, password: { error: true, msg: "Password should be minimum 10 characters or maximum 16 characters" } })
        }
        else if (forgotData.newPassword.search(/(?=.*[0-9])/)) {
            setErrorMsg({ ...errorMsg, password: { error: true, msg: "Password must have at least one digit" } })
        }
        else if (forgotData.newPassword.search(/(?=.*[A-Z])/)) {
            setErrorMsg({ ...errorMsg, password: { error: true, msg: "Password must have at least one capital letter" } })
        }
        else if (forgotData.newPassword.search(/(?=.*[a-z])/)) {
            setErrorMsg({ ...errorMsg, password: { error: true, msg: "Password must have at least one small letter" } })
        }
        else if (forgotData.newPassword.search(/(?=.*[!@%^?~_:?\]\[.{}-])/)) {
            setErrorMsg({ ...errorMsg, password: { error: true, msg: "Password must have at least one special character (~ ! @ % ^ _ - : ? . {} [])" } })
        }

        else if ((forgotData.newPassword.toLowerCase()).includes("godrej") || (forgotData.newPassword.toLowerCase()).includes("jerdog")) {
            setErrorMsg({ ...errorMsg, password: { error: true, msg: '"GODREJ" and "JERDOG" cannot be used as a Password' } })
        }
        else if (checkSequence(forgotData.newPassword)) {
            setErrorMsg({ ...errorMsg, password: { error: true, msg: "3 or more consecutive digits. e.g. 123, 321 cannot be used in the Password" } })
        }

        else if (forgotData.confirmPassword == "") {
            setErrorMsg({ ...errorMsg, password: { error: true, msg: "Please enter confirm password" } })
        }
        else if (forgotData.newPassword != forgotData.confirmPassword) {
            setErrorMsg({ ...errorMsg, password: { error: true, msg: "New password and Confirm Password not match" } })
        }
        else {
            //password reset API call
            fetch(environment.baseUrl + "resetPassword", {
                method: "PUT",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + verifyApiData.token
                },
                body: JSON.stringify({ newPassword: forgotData.newPassword, confirmPassword: forgotData.confirmPassword })
            }).then((result) => {
                result.json().then((res) => {
                    if (res.code === 200) {
                        handleClose();
                        setAlert({
                            msg: res.msg,
                            status: true
                        })
                    }
                    else {
                        setAlert({
                            msg: res.msg,
                            status: true
                        })
                    }
                })
            })
        }
    }

    // for resend OTP timer
    let [timer, setTimer] = useState(30);

    function startCountDown() {
        setTimer(30);
        let countdown = setInterval(() => {
            setTimer((timer) => {
                if (timer <= 0) {
                    clearInterval(countdown);
                }
                else {
                    setTimer(timer - 1);
                }
            });
        }, 1000)
    }

    return (

        <div className='container'>
            <Alert obj={alert} />

            <div className="row align-items-center justify-content-center" style={{ height: "100vh", marginTop: 0 }}>
                <div className="col-sm-5">
                    <Card className='shadow-lg login-box'>
                        <div className='login-card-img text-center'>
                            <Card.Img variant="top" className='text-center' style={{ width: "80%" }} src={fltlogo} />
                        </div>
                        <Card.Body>
                            <p className='mb-1'><b>Log In for a great experience </b></p>
                            <label>User ID</label>
                            <div className="input-group mb-3">
                                <span className="input-group-text ip-icon ip-icon-left"><i className='fa fa-user'></i></span>
                                <input type="text" name='userName' value={loginData.userName} onChange={getFormData} className="form-control ip-icon-right" placeholder="Username" autoComplete='off' />
                            </div>
                            <label>Password</label>
                            <div className="input-group mb-2">
                                <span className="input-group-text ip-icon ip-icon-left"><i className='fa fa-key'></i></span>
                                <input type={type.type} name='password' value={loginData.password} onChange={getFormData} className="form-control ip-icon-left ip-icon-right" placeholder='Password' autoComplete='off' />
                                <span className="input-group-text ip-icon ip-icon-right"><i className={type.iclass} onClick={togglePassword}></i></span>
                            </div>
                            {errorMsg.login.error ? <small className='error-text'>{errorMsg.login.msg}</small> : ""}
                            <Form.Group className='mt-3' controlId="formBasicCheckbox">
                                <label ><input type="checkbox" name="check" onChange={getFormData} /> By continuing, I agree to the <Button onClick={() => handleInfoType("term")} variant="link" className='px-0 pt-0'> Terms and Condition</Button> & <Button onClick={() => handleInfoType("policy")} variant="link" className='px-0 pt-0'>Privacy Policy</Button></label>
                            </Form.Group>
                            <div className="text-center mt-3">
                                <Button onClick={loginUser} variant="primary" className='btn-save' type="submit">
                                    Login
                                </Button><br></br>
                                {/* <Button variant="primary" className='btn-save mt-2' onClick={() => handelADLogin('b2b')}>
                                    Azure AD Login
                                </Button><br></br>
                                <Button variant="primary" className='btn-save mt-2' onClick={() => handelADLogin('b2c')}>
                                    External User
                                </Button><br></br> */}
                                <Button onClick={handleShow} className="mt-2" variant="link">
                                    Forgot Password?
                                </Button>
                            </div>
                        </Card.Body>
                    </Card>
                </div>

            </div>


            {/* // for forgate password */}
            <Modal show={showm} onHide={handleClose} centered backdrop="static" size='sm'>
                <Modal.Body>
                    <div className="row justify-content-center no-mt">

                        <img className="text-center" src={lock}></img>

                    </div>
                    <div className={screen.forgetPassword ? "row justify-content-center no-mt" : "row justify-content-center no-mt d-none"}>
                        <h6><b>Forgot Password</b></h6>
                        <p className='short-link mt-2' style={{ textAlign: "center", color: "#8c98b1" }}>Enter Your Email ID Associated With Your Account, We Will Send An OTP To Verify Your Identity</p>

                        <div className="col-sm-12 text-center">
                            <Form.Group className="mb-3" >
                                <Form.Control type="text" name='emailID' className="textbox-back" placeholder='Email ID' value={forgotData.emailID} onChange={getForgotData} />
                                {errorMsg.email.error ? <small className='error-text'>Please enter email ID first</small> : ""}
                            </Form.Group>

                            <button className="btn btn-save px-5" onClick={sendOtpToEmail}>
                                Submit
                            </button>< br />
                        </div>
                    </div>
                    <div className={screen.verifyOtp ? "row justify-content-center no-mt" : "row justify-content-center no-mt d-none"}>
                        <h6><b>Verify OTP</b></h6>
                        <p className='short-link mt-2' style={{ textAlign: "center", color: "#8c98b1" }}>OTP has been sent to your Email ID, please enter it below</p>

                        <div className="col-sm-12 text-center">
                            <Form.Group className="mb-3" >
                                <Form.Control type="text" name='otp' className="textbox-back text-center" placeholder='OTP' value={forgotData.otp} onChange={getForgotData} maxLength="4" />
                                {errorMsg.otp.error ? <small className='error-text'>{errorMsg.otp.msg}</small> : ""}
                            </Form.Group>
                            <Button variant="link" size="sm" onClick={sendOtpToEmail} disabled={timer > 0 ? true : false}>
                                Resend OTP  {timer > 0 ? timer + " s" : ""}
                            </Button><br></br>
                            <button className="btn btn-save px-2" onClick={verifySendOtp}>
                                Verify OTP
                            </button>< br />
                        </div>
                    </div>
                    <div className={screen.resetPassword ? "row justify-content-center no-mt" : "row justify-content-center no-mt d-none"}>
                        <h6><b>Reset Password</b></h6><br />
                        <p className=" mt-2" style={{ textAlign: "center", color: "#8c98b1" }}>Please enter following details</p>

                        <div className="col-sm-12 text-center">
                            <Form.Group className="mb-3" >
                                <Form.Label className='float-start'>New Password</Form.Label>
                                <Form.Control type="password" name='newPassword' className="textbox-back" placeholder='Enter Password' value={forgotData.newPassword} onChange={getForgotData} />
                            </Form.Group>
                            <Form.Group className="" >
                                <Form.Label className='float-start'>Confirm New Password</Form.Label>
                                <Form.Control type="password" name='confirmPassword' className="textbox-back" placeholder='Re-Enter Password' value={forgotData.confirmPassword} onChange={getForgotData} />
                            </Form.Group>
                            {errorMsg.password.error ? <p className='error-text'>{errorMsg.password.msg}</p> : ""}
                            <button className="btn btn-save px-5 mt-3" onClick={setNewPassword}>
                                Submit
                            </button>< br />
                        </div>
                    </div>
                    <div className="row justify-content-center no-mt">
                        <Button variant="link" onClick={handleClose} size="sm">
                            Go to Login
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>

            {/* model for term and policy */}
            <Modal show={infoShow} onHide={() => setInfoShow(false)} centered backdrop="static" size='lg'>
                <Modal.Header>
                    <Modal.Title>{infoType === "policy" ? "Privacy Policy" : "Terms and Condition"}</Modal.Title>
                    <button onClick={() => setInfoShow(false)} type="button" className="close">
                        <img src={close} alt="" />
                    </button>
                </Modal.Header>
                <Modal.Body className='logout-box'>
                    {
                        src == "" ?
                            <p className='text-center'>Loading Details ...</p>
                            :
                            <iframe src={src + "#toolbar=0&navpanes=0"} style={{ border: "none" }} height="350" width="100%" title="Iframe Example"></iframe>
                    }
                </Modal.Body>
            </Modal>
        </div>
    )
}
export default Local_Login

